import { capabilityLabels } from '../../materiels/materielDisplayMaps';

/**
 * Onglet Capacités.
 */
export default function MaterielDrawerCapabilitiesTab({ item, loading }) {
  if (loading) {
    return (
      <div className="space-y-2 p-1">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-7 rounded bg-gray-100 animate-pulse" />
        ))}
      </div>
    );
  }

  const caps = capabilityLabels(item?.capabilities);

  if (caps.length === 0) {
    return (
      <p className="text-sm text-gray-500">
        Aucune capacité déclarée pour ce matériel.
      </p>
    );
  }

  return (
    <ul className="flex flex-wrap gap-2">
      {caps.map((label) => (
        <li
          key={label}
          className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium border border-primary-100 bg-primary-50 text-primary-800"
        >
          {label}
        </li>
      ))}
    </ul>
  );
}
